import { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { useEffect, useState } from "react";

import type { AppProps } from "next/app";
import { CookiesProvider } from "react-cookie";
import Cookie from "js-cookie";
import AuthGuard from "src/components/AuthGuard";

import "../../styles/globals.css";
import "../../styles/react-datepicker.css";

function MyApp({ Component, pageProps }: AppProps<{ session: Session }>) {
  const [displayCookiesPolicy, setDisplayCookiesPolicy] = useState(false);

  useEffect(() => {
    if (Cookie.get("consentPolicy") === undefined) {
      setDisplayCookiesPolicy(true);
    }
  }, [displayCookiesPolicy]);

  /*
  const setCookiesState = (userData: string) => {
    // const minutes=12; ///12 minutes
    const minutes = 129600; /// 3months
    const d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    setCookie("consentPolicy", JSON.stringify(userData), {
      path: "/",
      expires: d,
      sameSite: true,
    });
  };
  */

  return (
    <SessionProvider session={pageProps.session}>
      <CookiesProvider>
        <AuthGuard />
        <Component {...pageProps} />

        {displayCookiesPolicy === true ? <div /> : null}
      </CookiesProvider>
    </SessionProvider>
  );
}

export default MyApp;
